import React, { useCallback, useEffect, useState } from "react";
import api, { errMsg } from "../../core/api";
import { useApp } from "../../core/AppContext";
import { fa, formatDate } from "../../core/format";
import Modal from "../../components/Modal";
import Table from "../../components/Table";
import LeaveFlowModal from "../records/LeaveFlow";
import ResponsiveList from "../../components/ResponsiveList";

const WHO = {
  staff: "درخواست‌های مرخصی‌ای که شما را به‌عنوان جانشین معرفی کرده‌اند",
  admin: "درخواست‌های مرخصی در انتظار تأیید مسئول ایمنی و آتش‌نشانی",
  manager: "درخواست‌های مرخصی در انتظار تأیید مدیر بندر",
};

export function DecisionModal({ item, approve, onClose, onDone }) {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const go = async () => {
    if (!approve && note.trim().length < 3) return setErr("دلیل رد را بنویسید");
    setBusy(true); setErr("");
    try {
      const { data } = await api.post(`/requests/${item.id}/leave-decision`, { approve, note: note.trim() });
      onDone(data);
    } catch (e) { setErr(errMsg(e)); setBusy(false); }
  };

  return (
    <Modal small title={approve ? "تأیید درخواست مرخصی" : "رد درخواست مرخصی"} onClose={() => !busy && onClose()}
      footer={
        <>
          <button className={`btn ${approve ? "" : "btn-danger"}`} onClick={go} disabled={busy}>{busy ? "در حال ثبت..." : approve ? "تأیید" : "رد درخواست"}</button>
          <button className="btn btn-ghost" onClick={onClose} disabled={busy}>انصراف</button>
        </>
      }>
      <div style={{ marginBottom: 10 }}>
        <b>{item.requesterName}</b>
        <div className="hint">از {formatDate(item.fromDate)} تا {formatDate(item.toDate)} · جانشین: {item.substituteName}</div>
      </div>
      {err && <div className="alert err">{err}</div>}
      <div className="field">
        <label>توضیحات{approve ? " (اختیاری)" : <span className="req">*</span>}</label>
        <textarea rows={4} maxLength={400} value={note} disabled={busy} onChange={(e) => { setNote(e.target.value); setErr(""); }} />
      </div>
    </Modal>
  );
}

export default function LeaveApprovals() {
  const { user, toast } = useApp();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dec, setDec] = useState(null); // { item, approve }
  const [flowId, setFlowId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await api.get("/requests/leave/inbox"); setRows(data.items); }
    catch (e) { toast(errMsg(e), "err"); } finally { setLoading(false); }
  }, [toast]);
  useEffect(() => { load(); }, [load]);

  const done = (d) => {
    setDec(null);
    if (d.stage === "approved") {
      toast(d.moved + d.removed > 0 ? `تأیید نهایی شد؛ شیفت ${fa(d.moved + d.removed)} روز به جانشین منتقل شد` : "تأیید نهایی شد");
    } else toast(d.stage === "rejected" ? "درخواست رد شد" : "تأیید شد و برای مرحله‌ی بعد ارسال شد");
    load();
  };

  return (
    <>
      <div className="page-head"><div><h2>تأیید مرخصی</h2><p>{WHO[user.role]}</p></div></div>
      <div className="card">
    <ResponsiveList
  loading={loading}
  rows={rows}
  empty="درخواستی در انتظار تأیید شما نیست"
  columns={[
    { key: "requesterName", label: "درخواست‌دهنده", render: (r) => <b>{r.requesterName}</b> },
    { key: "range", label: "بازه‌ی مرخصی", render: (r) => `${formatDate(r.fromDate)} تا ${formatDate(r.toDate)}` },
    { key: "substituteName", label: "جانشین" },
    { key: "title", label: "عنوان" },
    { key: "notes", label: "توضیحات", render: (r) => <div className="clip" title={[r.subNote, r.supNote].filter(Boolean).join(" | ")}>{[r.subNote, r.supNote].filter(Boolean).join(" | ") || "—"}</div> },
  ]}
  mobileTitle={(r) => r.requesterName}
  mobileBadge={(r) => <span className="mc-date">{formatDate(r.fromDate)} تا {formatDate(r.toDate)}</span>}
  mobileMeta={(r) => [
    { icon: "fa-solid fa-user-check", label: "جانشین", value: r.substituteName },
    { icon: "fa-regular fa-file-lines", label: "عنوان", value: r.title },
    ...(r.subNote || r.supNote ? [{ icon: "fa-regular fa-comment", full: true, label: "توضیحات", value: [r.subNote, r.supNote].filter(Boolean).join(" | ") }] : []),
  ]}
  actions={(r) => (
    <>
      <button className="icon-btn" title="مراحل و جزئیات" onClick={() => setFlowId(r.id)}><i className="fa-solid fa-list-check" /></button>
      <button className="btn btn-sm" onClick={() => setDec({ item: r, approve: true })}><i className="fa-solid fa-check" /> تأیید</button>
      <button className="btn btn-sm btn-danger" onClick={() => setDec({ item: r, approve: false })}><i className="fa-solid fa-xmark" /> رد</button>
    </>
  )}
/>
      </div>
      {dec && <DecisionModal item={dec.item} approve={dec.approve} onClose={() => setDec(null)} onDone={done} />}
      {flowId && <LeaveFlowModal id={flowId} onClose={() => setFlowId(null)} />}
    </>
  );
}